import React from 'react';
import { Mail, Instagram, Music2, Send } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();
  
  const contactMethods = [
    {
      icon: <Mail size={32} />,
      title: t('contact_email'),
      value: 'asso.hmditeam@gmail.com',
      link: 'mailto:asso.hmditeam@gmail.com',
      color: 'red'
    },
    {
      icon: <Instagram size={32} />,
      title: t('contact_instagram'),
      value: '@hdm_i_team',
      link: 'https://instagram.com/hdm_i_team',
      color: 'pink'
    },
    {
      icon: <Music2 size={32} />,
      title: t('contact_tiktok'),
      value: '@hdmi.team',
      link: 'https://tiktok.com/@hdmi.team',
      color: 'cyan'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-zinc-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('contact_title')}
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-6"></div>
            <p className="text-gray-400 text-lg">
              {t('contact_subtitle')}
            </p>
          </div>

          {/* Contact Methods */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {contactMethods.map((method, index) => (
              <a
                key={index}
                href={method.link}
                target={method.link.startsWith('http') ? '_blank' : '_self'}
                rel={method.link.startsWith('http') ? 'noopener noreferrer' : ''}
                className="block"
              >
                <Card className="bg-zinc-800/50 backdrop-blur-sm border-zinc-700 hover:border-red-500 transition-all duration-300 hover:transform hover:scale-105 p-8 h-full">
                  <div className="text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/20 text-red-500 mb-4">
                      {method.icon}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{method.title}</h3>
                    <p className="text-gray-400 break-all">{method.value}</p>
                  </div>
                </Card>
              </a>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <Card className="bg-gradient-to-br from-zinc-800/50 to-zinc-900/50 backdrop-blur-sm border-zinc-700 p-8 md:p-12">
              <div className="max-w-2xl mx-auto">
                <h3 className="text-3xl font-bold text-white mb-4">
                  {t('contact_ready_title')}
                </h3>
                <p className="text-gray-400 text-lg mb-8">
                  {t('contact_ready_desc')}
                </p>
                <Button
                  onClick={() => window.open('https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-battle-of-the-year-next-generation', '_blank')}
                  className="bg-red-500 hover:bg-red-600 text-white font-bold px-10 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-red-500/50"
                >
                  <Send className="mr-2" size={24} />
                  {t('contact_reserve_now')}
                </Button>
              </div>
            </Card>
          </div>

          {/* Social Media Follow Section */}
          <div className="mt-12 text-center">
            <p className="text-gray-400 mb-4">{t('contact_follow')}</p>
            <div className="flex justify-center gap-6">
              <a
                href="https://instagram.com/hdm_i_team"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-colors duration-300"
              >
                <Instagram size={32} />
              </a>
              <a
                href="https://tiktok.com/@hdmi.team"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-colors duration-300"
              >
                <Music2 size={32} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
